/* eslint-disable max-classes-per-file */

import * as React from "react";
import classnames from "classnames";

import Select from "react-select";
import { Link } from "react-router-dom";

import { DocShape, DocTypes, ConditionShape } from "@eave/shared/types/api";
import { docTypeToHumanStr, selectableDocTypes } from "../../shared";
import DocumentUploader from "../../../DocumentUploader";
import DropdownModal from "../../../shared/DropdownModal";
import DocRender from "../DocRender";

const FontAwesome = require("react-fontawesome");
const styles = require("./styles.module.scss");

interface DocumentModalProps {
  documents: DocShape[];
  isVisible: boolean;
  onHide: Function;
  onUpdate: Function;
  appID: number;
  condition: ConditionShape;
}

const docTypeSelectOpts: any = selectableDocTypes.map(t => ({
  value: t,
  label: docTypeToHumanStr(t),
}));

const docRow = doc => (
  <div key={doc.id} className={classnames(styles.docRow, "row")}>
    <div className="col-sm-10">
      <strong className={styles.originalFilename}>{doc.original_filename}</strong>
      <span className={styles.docType}>{doc.type}</span>
    </div>
    <div className="col-sm-1">
      <Link
        target="_blank"
        to={`/underwriter/app/${doc.loan_application_id}/DocumentsHurdle?d=${doc.id}`}
      >
        <FontAwesome title="Open Documents Hurdle" name="edit" />
      </Link>
    </div>
    <div className="col-sm-1">
      <DropdownModal>
        {{
          trigger: <FontAwesome title="Preview Document" name="eye" />,
          content: (
            <div className={styles.docPreview}>
              <DocRender doc={doc} />
            </div>
          ),
        }}
      </DropdownModal>
    </div>
  </div>
);

class DocumentModal extends React.Component<DocumentModalProps, any> {
  constructor(props) {
    super(props);

    const {
      condition: { document_type },
    } = this.props;

    this.state = { docType: document_type || DocTypes.ConditionAttachment };
  }

  onSelect = option => {
    this.setState({ docType: option.value });
  };

  render() {
    const { docType } = this.state;
    const {
      documents,
      appID,
      condition: { id, owner_entity_id, owner_entity_type },
      onUpdate,
    } = this.props;

    return (
      <div className={styles.docModal}>
        {documents && documents.length && (
          <div>
            <h4> Linked Docs </h4>
            <div className="row">{documents.map(docRow)}</div>
          </div>
        )}
        <h4> New Document </h4>
        <Select
          placeholder="Select type"
          clearable={false}
          searchable
          value={docType}
          options={docTypeSelectOpts}
          onChange={this.onSelect}
        />
        <DocumentUploader
          showOnlyCurrentUploadsOfType
          documentType={docType}
          prompt="Attach a document"
          applicationID={appID}
          conditionID={id}
          onUpload={onUpdate}
          ownerEntityID={owner_entity_id}
          ownerEntityType={owner_entity_type}
        />
      </div>
    );
  }
}

interface LinkedDocumentsProps {
  documents: DocShape[];
  condition: ConditionShape;
  onUpdate: Function;
  appID: number;
}

class LinkedDocuments extends React.Component<LinkedDocumentsProps, any> {
  state = { showDocuments: false };

  toggleShowDocuments = () => {
    this.setState(prev => ({ showDocuments: !prev.showDocuments }));
  };

  render() {
    const { showDocuments } = this.state;
    const { documents, onUpdate, appID, condition } = this.props;

    const usedDocuments = documents && documents.filter((doc: DocShape) => doc.used);
    const usedDocumentsLength = usedDocuments && usedDocuments.length;

    return (
      <div className={styles.documents}>
        <DropdownModal>
          {{
            trigger: (
              <>
                {usedDocumentsLength ? (
                  <>
                    <FontAwesome title="View Linked Documents" name="file-text" /> (
                    {usedDocumentsLength})
                  </>
                ) : (
                  <FontAwesome title="Attach a document" name="plus" />
                )}
              </>
            ),
            content: (
              <DocumentModal
                documents={usedDocuments}
                isVisible={showDocuments}
                onHide={this.toggleShowDocuments}
                onUpdate={onUpdate}
                appID={appID}
                condition={condition}
              />
            ),
          }}
        </DropdownModal>
      </div>
    );
  }
}

export default LinkedDocuments;
